// react-redux
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import Root from "./components/Root";
import configureStore from "./store/store";

// css
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

// Initialize Sentry
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    beforeSend(event) {
      // Scrub sensitive data
      if (event.request?.data) {
        const data = event.request.data;
        if (typeof data === 'string') {
          try {
            const parsed = JSON.parse(data);
            if (parsed.phone) parsed.phone = '[REDACTED]';
            if (parsed.email) parsed.email = '[REDACTED]';
            if (parsed.dob) parsed.dob = '[REDACTED]';
            if (parsed.token) parsed.token = '[REDACTED]';
            if (parsed.confirmationTokenId) parsed.confirmationTokenId = '[REDACTED]';
            event.request.data = JSON.stringify(parsed);
          } catch (e) {
            // Not JSON, leave as is
          }
        }
      }
      return event;
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('popstate', (event) => {
    window.securedNav = true;
  });

  let store;

  if (window.sessionStorage.config && !window.sessionStorage.appointments) {
    const config = JSON.parse(window.sessionStorage.config);

    const preloadedState = {
      config: config
    };

    store = configureStore(preloadedState);

  } else if (window.sessionStorage.appointments) {
    let appointments;
    let config;

    if (window.sessionStorage.config) {
      config = JSON.parse(window.sessionStorage.config);
    } else {
      config = {};
    }

    if (typeof window.sessionStorage.appointments === "string") {
      appointments = window.sessionStorage.appointments;
    } else {
      appointments = JSON.parse(window.sessionStorage.appointments);
    }

    const preloadedState = {
      config: config,
      appointments: appointments
    }

    store = configureStore(preloadedState);

  } else {
    store = configureStore();
  }

  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(<Root store={store} />);
});
